import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

class Currency extends React.Component {

    static formatCurrencyLabel({ currency_symbol, currency }) {
        return `${currency_symbol} ${currency}`;
    }

    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);

        this.state = {
            selected: this.props.selected
        };
    }

    onChange(e) {
        const newValue = e.target.value;
        this.setState({
            selected: newValue
        });

        gofor('/localization/change_currency', {
            method: 'POST',
            body : JSON.stringify({
                target_currency : newValue
            })
        }).then((response) => {
            if (response.ok) {
                location.reload();
            }
        });
    }

    render() {
        const { selected } = this.state;
        const { supportedCurrencies } = this.props;

        return (
            <div className="currency-selector">
                <select value={selected} onChange={this.onChange}>
                    {supportedCurrencies.map((currencyObj) =>
                        <option key={currencyObj.currency} value={currencyObj.currency}>{Currency.formatCurrencyLabel(currencyObj)}</option>
                    )}
                </select>
            </div>
        );
    }
}

Currency.propTypes = {
    selected: PropTypes.string,
    supportedCurrencies: PropTypes.arrayOf(PropTypes.shape({
        currency: PropTypes.string,
        currency_symbol: PropTypes.string
    }))
};

export default Currency;



// WEBPACK FOOTER //
// ./src/components/Currency/index.js